import { FC } from 'react';

interface ISkeletonItem {
  isWide: boolean;
}

const DEFAULT_SKELETON_COUNTS = 4;

export function getSkeletonItemsNodes(items: ISkeletonItem[], SkeletonComponent: FC<ISkeletonItem>) {
  const skeletonItems = items.length
    ? items
    : /* istanbul ignore next */ Array.from<ISkeletonItem>({ length: DEFAULT_SKELETON_COUNTS }).fill({ isWide: true });

  return skeletonItems.map(({ isWide }, index) => <SkeletonComponent key={`skeleton-item-${index}`} isWide={isWide} />);
}
